Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByPredicate = exports.searchItems = exports.paginate = exports.findIndexes = exports.removeAt = exports.replaceAt = exports.insertAt = exports.splice = exports.unshift = exports.push = undefined;

var _utilsValue = require('@pcty/utils-value');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var push = exports.push = function push(array) {
  for (var _len = arguments.length, items = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    items[_key - 1] = arguments[_key];
  }

  if (array === undefined || array === null || array.length <= 0) return [].concat(items);

  return [].concat(_toConsumableArray(array), items);
};

var unshift = exports.unshift = function unshift(array) {
  for (var _len2 = arguments.length, items = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    items[_key2 - 1] = arguments[_key2];
  }

  if (array === undefined || array === null || array.length <= 0) return [].concat(items);

  return [].concat(items, _toConsumableArray(array));
};

var splice = exports.splice = function splice(array, start, deleteCount) {
  for (var _len3 = arguments.length, items = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    items[_key3 - 3] = arguments[_key3];
  }

  if (array === undefined || array === null || array.length <= 0) return [].concat(items);

  return [].concat(_toConsumableArray(array.slice(0, start)), items, _toConsumableArray(array.slice(start + deleteCount)));
};

var insertAt = exports.insertAt = function insertAt(array, index, item) {
  if (array === undefined || array === null || array.length <= 0) return array;

  if (index < 0 || array.length <= index) throw 'Index outside of bounds of the array.';

  return splice(array, index, 0, item);
};

var replaceAt = exports.replaceAt = function replaceAt(array, index, item) {
  if (array === undefined || array === null || array.length <= 0) return array;

  if (index < 0 || array.length <= index) throw 'Index outside of bounds of the array.';

  return splice(array, index, 1, item);
};

var removeAt = exports.removeAt = function removeAt(array, index) {
  if (array === undefined || array === null || array.length <= 0 || index < 0 || array.length <= index) return array;

  return array.slice(0, index).concat(array.slice(index + 1));
};

var findIndexes = exports.findIndexes = function findIndexes(array, predicate) {
  var output = [];

  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i])) {
      output = [].concat(_toConsumableArray(output), [i]);
    }
  }

  return output;
};

var paginate = exports.paginate = function paginate(array, pageSize, pageNumber) {
  pageNumber -= 1; // because pages logically start with 1, but technically with 0
  return array.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
};

var searchItems = exports.searchItems = function searchItems(array, search) {
  var results = array.filter(function (item) {
    var found = false;
    Object.keys(search).forEach(function (key) {
      if (searchTree(item, key, search[key])) {
        found = true;
      }
    });

    return found;
  });

  return results;
};

// to be used with lodash/sortBy
var sortByPredicate = {
  key: function key(_key4) {
    return function (x) {
      return _key4 in x ? x[_key4] : x;
    };
  },
  string: function string(key) {
    return function (x) {
      return key in x && (0, _utilsValue.isNotNullOrEmpty)(x[key]) ? x[key].toLowerCase() : null;
    };
  },
  dateString: function dateString(key) {
    return function (x) {
      return key in x && (0, _utilsValue.isNotNullOrEmpty)(x[key]) ? new Date(x[key]) : null;
    };
  }
};

// Private
exports.sortByPredicate = sortByPredicate;
var searchTree = function searchTree(item, key, value) {
  if (key.indexOf('.') >= 0) {
    var remainder = key.slice(key.indexOf('.') + 1);
    var currentItem = item[key.split('.')[0]];
    if ((0, _utilsValue.isNotNullOrEmpty)(currentItem)) {
      if (Array.isArray(currentItem)) {
        for (var i = 0; i < currentItem.length; i++) {
          if (searchTree(currentItem[i], remainder, value)) return true;
        }
      } else if (currentItem[remainder].toLowerCase().indexOf(value.toLowerCase()) >= 0) return true;
    }
  } else if ((0, _utilsValue.isNotNullOrEmpty)(item[key]) && item[key].toLowerCase().indexOf(value.toLowerCase()) >= 0) return true;
};